module.exports = __webpack_public_path__ + "img/IT0000534155847.f5286e18.png";